import { Component, ElementRef, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgIf } from '@angular/common';

const VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => EditableCellComponent),
    multi: true,
};

@Component({
    selector: 'editable-cell',
    templateUrl: './editable-cell.component.html',
    styleUrls: ['./editable-cell.component.css'],
    providers: [VALUE_ACCESSOR],
    standalone: true,
    imports: [NgIf],
})
export class EditableCellComponent implements ControlValueAccessor {
    @ViewChild('writeComponent')
    writeComponent!: ElementRef;

    @ViewChild('readComponent')
    readComponent!: ElementRef;

    @Output()
    valueChange: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    isReadOnly: boolean = true;

    @Input()
    model: any;

    @Input()
    path!: string;

    editing: boolean = false;

    public onChange: Function = Function.prototype;
    public onTouched: Function = Function.prototype;

    get writeWidth() {
        return this.readComponent.nativeElement.getBoundingClientRect().width;
    }

    writeValue(value: any) {
        this.model = value;
    }

    registerOnChange(fn: (_: any) => {}): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => {}): void {
        this.onTouched = fn;
    }

    onBlur() {
        this.editing = false;
    }

    onValueChange(e: Event & { target: HTMLInputElement }) {
        let parsedValue = parseFloat(e.target.value);
        if (isNaN(parsedValue)) {
            console.error(
                'measures -> onValueChange method - e.target.value cannot be parsed (measures can be corrupted)',
                e.target,
            );
        } else {
            this.model[this.path] = parsedValue;
            this.valueChange.emit(this.model);
        }
    }

    onEdit() {
        if (this.isReadOnly) return;

        this.editing = true;
        setTimeout(() => {
            this.writeComponent.nativeElement.focus();
        }, 0);
    }
}
